import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Fade from '@material-ui/core/Fade';
import { withStyles } from '@material-ui/core/styles';
import { HeaderMenu, Footer } from 'aurora-components';
import dataMenu from 'aurora-api/ui/menu';
import { injectIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import styles from '../styles';

function AuroraPrimaryMenu(props) {
  const {
    classes,
    children,
    pageLoaded,
    history,
    toggleDrawer,
    sidebarOpen,
    loadTransition,
    signOut,
    isLogin,
    isGuest,
    userAttr,
  } = props;
  const pathName = window.location.pathname;
  const { search } = useLocation();
  const isMobile = new URLSearchParams(search).get('mobile');
  return (
    <Fragment>
      <HeaderMenu
        type='mega-menu'
        dataMenu={dataMenu}
        history={history}
        toggleDrawerOpen={toggleDrawer}
        openMobileNav={sidebarOpen}
        loadTransition={loadTransition}
        logoLink='/'
        signOut={signOut}
        isLogin={isLogin}
        userAttr={userAttr}
        isGuest={isGuest}
      />
      <main className={classNames(classes.content)} id='mainContent'>
        {!pageLoaded && <img src='/images/spinner.gif' alt='spinner' className={classes.circularProgress} />}
        <Fade in={pageLoaded} {...(pageLoaded ? { timeout: 700 } : {})}>
          <div className={!pageLoaded ? classes.hideApp : ''}>{children}</div>
        </Fade>
      </main>
      {!isMobile && isMobile !== true && !pathName.match('/services') && !pathName.match('/elife-service') && (
        <Footer history={history} />
      )}
    </Fragment>
  );
}

AuroraPrimaryMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  history: PropTypes.object.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  loadTransition: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  pageLoaded: PropTypes.bool.isRequired,
  signOut: PropTypes.func.isRequired,
  isLogin: PropTypes.bool,
  isGuest: PropTypes.bool,
  userAttr: PropTypes.object.isRequired,
};

AuroraPrimaryMenu.defaultProps = {
  isLogin: false,
  isGuest: false,
};

export default withStyles(styles)(injectIntl(AuroraPrimaryMenu));
